import React, { Component } from 'react';
import {withRouter} from 'react-router-dom';
import withStyles from 'react-jss'
import {withContext} from '../../../custom/StateProvider';
//import Utils from '../../../custom/utils';
import {API} from "../../../../config";
/*import _ from 'lodash';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';*/
import {connect} from "react-redux";
import red from "@material-ui/core/colors/red";
import Utils from "../../../custom/utils";

const wallet = API.service('wallet');
const moment = require('moment');

const styles = theme => ({
    tableRow:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        '&:nth-of-type(2n)':{
            backgroundColor:'#f6f6f6'
        },
        '& td':{
            padding:7,
        },
        '&:first-of-type':{
            borderTop:0,
        },
    },
    tableHead:{
        borderWidth:'1px 0 1px 0',
        borderColor:'#e6e6e6',
        backgroundColor:'#6e6e6e',
        color:'white'
    },
    accountDetails:{
        width:'300px',
        position:'absolute',
        display:'none',
        //border:'2px solid ' + theme.navigation.selected.backgroundColor,
        backgroundColor:'white',
        top:0,
        right:50,
        zIndex:1000,
    },
    bankDetails:{
        '&:hover .details_drawer':{
            display:'block'
        }
    },
    debutton:{
        padding:'5px 12px',
        //background:theme.navigation.selected.backgroundColor,
        //color:theme.navigation.selected.contrast,
        borderRadius:3,
        boxShadow:'2px 2px 2px #eee',

        '&:hover':{
            //background:theme.navigation.hover.backgroundColor,
            //color:theme.navigation.selected.contrast,
        }
    },
    formControl:{
      width:'100%'
    },
    redButton: {
      color: theme.palette.getContrastText(red[500]),
      backgroundColor: red[500],
      '&:hover': {
        backgroundColor: red[700],
      },
    },
    greyed:{
      color:'#6e6e6e',
      fontStyle:'italic'
    }
});

class WalletBalance extends Component {
  state={
    balance: '',
  };

  componentDidMount = () => {
    wallet.find({query:{type:'balance_period',_currency:this.props.currentAccount.currency,_timestamp:moment(this.props.timestamp).format('YYYY-MM-DD HH:MM:SS')}}).then(i=>{
      console.log(i,this.props.currentAccount.currency ,this.props.timestamp, moment(this.props.timestamp).format('YYYY-MM-DD HH:MM:SS'))
      this.setState({
        balance: i.balance
      })
    })
  };

    render() {
      const {classes} = this.props;
      return (
        <span className={classes.greyed}>{(Utils.addThousandCommasTwoDec(this.state.balance, '0,0.00') === '0.00') ? '' : Utils.addThousandCommasTwoDec(this.state.balance, '0,0.00')}</span>
      )
    }
}

function mapStateToProps({auth})
{
  return {
    user: auth.user
  }
}

export default withContext(withStyles(styles,{withTheme:true})(withRouter(connect(mapStateToProps)(WalletBalance))));
